import React from "react";
import { Modal, notification } from "antd";
import GistEditorForm from "../../shared/components/GistEditorForm";

const modalStyles = {
  mask: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(4px)',
  },
  content: {
    borderRadius: 8,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    border: '1px solid var(--color-border)',
  },
};

const CreateGistModal: React.FC<{
  visible: boolean;
  onClose: () => void;
  subjectId: number | undefined;
  parentGistId?: number;
  defaultSaveAsDraft?: boolean;
  intent?: "normal" | "linked-draft";
}> = ({ visible, onClose, subjectId, parentGistId, defaultSaveAsDraft = false, intent = "normal" }) => {

  const handleSuccess = () => {
    notification.success({
      message: "Success!",
      description: "Gist created successfully!",
    });
    onClose();
  };

  if (!subjectId) return null;

  const modalTitle = intent === "linked-draft"
    ? "🔗 Create Linked Draft Gist"
    : parentGistId
      ? "↳ Create Reply Gist"
      : "📝 Create New Gist";

  return (
    <Modal
      title={
        <span style={{ color: 'var(--color-forest)', fontWeight: 600 }}>
          {modalTitle}
        </span>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      maskStyle={modalStyles.mask}
      styles={{ content: modalStyles.content }}
      destroyOnClose
    >
      <GistEditorForm
        subjectId={subjectId}
        parentGistId={parentGistId}
        onSuccess={handleSuccess}
        onCancel={onClose}
        defaultSaveAsDraft={defaultSaveAsDraft}
        publishedSubmitLabel={intent === "linked-draft" ? "Create and publish" : undefined}
        draftSubmitLabel={intent === "linked-draft" ? "Create linked draft" : undefined}
        draftOptionLabel={intent === "linked-draft" ? "Keep this linked target as a private draft" : undefined}
      />
    </Modal>
  );
};

export default CreateGistModal;
